import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_novelty,
    CREATE_NOVELTY,
    createNovelty,
    getAllNovelty,
    get_report,
    GET_REPORT,
    getItemNovelty, updateNovelty, UPDATE_NOVELTY, UPDATE_NOVELTY_SUPER, updateNoveltySuper
} from '../../../redux/novelty';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllOperator} from "../../../redux/operator";
import {getAllTypeNovelty} from "../../../redux/type_novelty";
import {searchEmployees} from "../../../redux/employees";
import Card from "../../../components/card";
import { URLAPI } from "../../../config"
import Modal from "../../../components/modal";


const NovedadesAdmin = (props) => {
    const dispatch = useDispatch();

    /* Usando el gancho useSelector para obtener el estado del módulo de noveltyas. */
    const _get_all_novelty = useSelector((state) => state.novelty_module._get_all_novelty);

    const _get_all_operator = useSelector((state) => state.operator_module._get_all_operator);
    const _get_all_type_novelty = useSelector((state) => state.type_novelty_module._get_all_type_novelty);

    const _create_novelty = useSelector((state) => state.novelty_module._create_novelty);
    const _update_novelty = useSelector((state) => state.novelty_module._update_novelty);
    const _update_novelty_super = useSelector((state) => state.novelty_module._update_novelty_super);

    const _get_report = useSelector((store) => store.novelty_module._get_report);
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllNovelty(token));
        // eslint-disable-next-line
    }, [token, dispatch]);

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [establishment, setEstablishment] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [employee_select, setEmployeeSeelct] = useState([]);
    const [operator, setOperator] = useState([]);
    const [typeNovelty, setTypeNovelty] = useState([]);
    const [idType, setIdType] = useState(0);
    const [dateNovelty, setDateNovelty] = useState('');
    const [observation, setObservation] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + ' (' + element.codigo + ')'
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList]);

    useEffect(() => {
        if (_get_all_operator && _get_all_operator.data && _get_all_operator.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_operator.data.datos.map(element => {
                if (element.activo === true) {
                    array.push({
                        value: element.id,
                        label: element.nombre
                    })
                }
            })
            setOperator(array);
        }
    }, [_get_all_operator]);

    useEffect(() => {
        if (_get_all_type_novelty && _get_all_type_novelty.data && _get_all_type_novelty.data.datos) {
            let array = [];
            // eslint-disable-next-line
            _get_all_type_novelty.data.datos.map(element => {
                if (element.activo === true) {
                    array.push({
                        value: element.id,
                        label: element.descripcion
                    })
                }
            })
            setTypeNovelty(array);
        }
    }, [_get_all_type_novelty]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Tipo de novedad', id: 2},
        {name: 'Operario', id: 3},
        {name: 'Establecimiento', id: 4},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_establishment: false,
        id_establishment: 0,
        visible_type_novelty: false,
        id_type_novelty: 0,
        visible_operator: false,
        id_operator: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_establecimiento: 0,
        establecimiento: "",
        id_tipo_novedad: 0,
        tipo_novedad: "",
        id_operario: 0,
        operario: "",
        comentario: "",
        fecha_novedad: "",
        empleados: [],
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (_create_novelty.status === 201) {
            toast.success("Novedad creada correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_novelty(CREATE_NOVELTY));
            dispatch(getAllNovelty(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_novelty.status !== 0) {
            toast.error(_create_novelty.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_novelty(CREATE_NOVELTY));
            setIsLoading(false);
        }
    }, [_create_novelty, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_novelty && _get_all_novelty.data && _get_all_novelty.data.datos) {
            setDatas(_get_all_novelty.data.datos);
        }

    }, [_get_all_novelty, count, props]);

    const loadFunc = () => {
        if (_get_all_novelty.data.datos) {
            if (_get_all_novelty.data.datos.length > count) {
                const ordenado = _get_all_novelty.data.datos.sort((a, b) => {
                    return new Date(b.fecha_novedad + ' 00:00:00') - new Date(a.fecha_novedad + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setEstablishmentSelectFilter([]);
        setOperatorSelectFilter([]);
        setTypeNoveltySelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_novelty.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_type_novelty: false,
                id_type_novelty: 0,
                visible_operator: false,
                id_operator: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3' || e.target.value === '4') {
            if (e.target.value === '2') {
                dispatch(getAllTypeNovelty(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_type_novelty: true,
                    id_type_novelty: 0,
                    visible_operator: false,
                    id_operator: 0,
                });
            }
            if (e.target.value === '3') {
                dispatch(getAllOperator(token));
                setOtherFilter({
                    visible_establishment: false,
                    id_establishment: 0,
                    visible_type_novelty: false,
                    id_type_novelty: 0,
                    visible_operator: true,
                    id_operator: 0,
                });
            }
            if (e.target.value === '4') {
                setOtherFilter({
                    visible_establishment: true,
                    id_establishment: 0,
                    visible_type_novelty: false,
                    id_type_novelty: 0,
                    visible_operator: false,
                    id_operator: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_establishment: false,
                id_establishment: 0,
                visible_type_novelty: false,
                id_type_novelty: 0,
                visible_operator: false,
                id_operator: 0,
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_establecimiento" || e.target.name === "id_tipo_novedad" || e.target.name === "id_operario") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const getEmployees = async (id_establecimiento) => {
        const params = '?id_establecimiento=' + id_establecimiento + '&&buscar=1'
        const response = await searchEmployees(token, params)
        if (response && response.data && response.data.datos) {
            let options = response.data.datos.map((item) => {
                return {
                    value: item.id,
                    label: item.nombres + ' ' + item.apellidos,
                };
            });
            setEmployees(options);
        }
    }

    const [establishment_select, setEstablishmentSelect] = useState([]);

    const handleChangeEstablishment = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_establecimiento']: parseInt(e.value),
            // eslint-disable-next-line
            ['establecimiento']: parseInt(e.label),
        });
        setEstablishmentSelect(e);
        getEmployees(parseInt(e.value));
        setEmployeeSeelct([]);
    }

    const [operator_select, setOperatorSelect] = useState([]);

    const handleChangeOperator = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_operario']: parseInt(e.value),
            // eslint-disable-next-line
            ['operario']: parseInt(e.label),
        });
        setOperatorSelect(e);
    }

    const handleChangeEmployee = (e) => {
        setEmployeeSeelct(e);
    }

    const [type_novelty_select, setTypeNoveltySelect] = useState([]);

    const handleChangeTypeNovelty = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_tipo_novedad']: parseInt(e.value),
            // eslint-disable-next-line
            ['tipo_novedad']: parseInt(e.label),
        });
        setTypeNoveltySelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        let empleados = [];
        employee_select.forEach(em => {
            empleados.push(em.value);
        })

        form.empleados = empleados;

        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento");
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_novedad === 0) {
            toast.error("Debe seleccionar el tipo de la novedad");
            setIsLoading(false);
            return;
        }
        if (form.id_operario === 0) {
            toast.error("Debe seleccionar el operario");
            setIsLoading(false);
            return;
        }
        if (form.fecha_novedad === "") {
            toast.error("Debe seleccionar la fecha de la novedad");
            setIsLoading(false);
            return;
        }
        if (form.comentario === "") {
            toast.error("Debe ingresar un comentario");
            setIsLoading(false);
            return;
        }
        if (form.empleados.length === 0) {
            toast.error("Debe seleccionar al menos un empleado");
            setIsLoading(false);
            return;
        }
        dispatch(createNovelty(token, form))
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_novelty.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_novelty.data.datos.filter(element => {
            if (element.establecimiento.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_novelty.data.datos.filter(x => {
                    if (x.fecha_novedad) {
                        let fecha = new Date(x.fecha_novedad);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_novelty(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_novelty(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_establecimiento': other_filter.id_establishment,
            'id_operario': other_filter.id_operator,
            'id_tipo_novedad': other_filter.id_type_novelty,
        }, token));

    }

    const [establishment_select_filter, setEstablishmentSelectFilter] = useState([]);

    const handleChangeEstablishmentFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_establishment': parseInt(e.value),
        });
        let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_establecimiento) === parseInt(e.value));
        setDatas(va);
        setEstablishmentSelectFilter(e);
    }

    const [operator_select_filter, setOperatorSelectFilter] = useState([]);

    const handleChangeOperatorFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_operator': parseInt(e.value),
        });
        let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_operario) === parseInt(e.value));
        setDatas(va);
        setOperatorSelectFilter(e);
    }

    const [type_novelty_select_filter, setTypeNoveltySelectFilter] = useState([]);

    const handleChangeTypeNoveltyFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_type_novelty': parseInt(e.value),
        });
        let va = _get_all_novelty.data.datos.filter(x => parseInt(x.id_tipo_novedad) === parseInt(e.value));
        setDatas(va);
        setTypeNoveltySelectFilter(e);
    }

    const initSelect = {
        id: 0,
        codigo_establecimiento: "",
        establecimiento: "",
        secuencial: "",
        tipo_novedad: "",
        operario: "",
        comentario: "",
        fecha_novedad: "",
        empleados: [],
        nota: "",
        foto: "",
        observacion: ""
    };

    const [DataSelected, setDataSelected] = useState(initSelect);
    const [modalNota, setModalNota] = useState(false);
    const [nota, setNota] = useState(false);
    const [modalUpdateNovelty, setModalUpdateNovelty] = useState(false);
    const [foto, setFoto] = useState('');

    const onItemClickListener = async (item) => {
        const response = await getItemNovelty(token, item.id);
        if (response && response.data && response.data.datos) {
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_novelty.status === 200) {
            toast.success(_update_novelty.data.mensaje);
            dispatch(clear_novelty(UPDATE_NOVELTY));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModalNota(false);
        } else if (_update_novelty.status !== 0) {
            toast.error(_update_novelty.message);
            dispatch(clear_novelty(UPDATE_NOVELTY));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_novelty, dispatch])

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!foto) {
            toast.error("Debe seleccionar una imagen");
            setIsLoading(false);
            return;
        }
        dispatch(updateNovelty(token, DataSelected.id, {'foto': foto, 'nota': nota}))
    }

    useEffect(() => {
        if (_update_novelty_super.status === 200) {
            toast.success(_update_novelty_super.data.mensaje);
            dispatch(clear_novelty(UPDATE_NOVELTY_SUPER));
            onItemClickListener(DataSelected);
            setIsLoading(false);
            setModalUpdateNovelty(false);
        } else if (_update_novelty_super.status !== 0) {
            toast.error(_update_novelty_super.message);
            dispatch(clear_novelty(UPDATE_NOVELTY_SUPER));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_novelty_super, dispatch])

    const handleUpdateNoveltySubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (idType === 0) {
            toast.error("Debe seleccionar el tipo de novedad");
            setIsLoading(false);
            return;
        }
        if (dateNovelty === "") {
            toast.error("Debe seleccionar la fecha de la novedad");
            setIsLoading(false);
            return;
        }
        if (observation === "") {
            toast.error("Debe ingresar una observación para la novedad");
            setIsLoading(false);
            return;
        }
        dispatch(updateNoveltySuper(token, DataSelected.id, {'id_tipo': idType, 'fecha_novedad': dateNovelty, 'observacion': observation}))
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Novedades"
                            items={[{label: "Listado novedades", link: "/novedades"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">

                    <div className="content-area-wrapper" style={{margin: 0}}>


                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">

                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_novelty").length > 0 &&
                                                <Button
                                                    text="Crear"
                                                    onChange={() => {
                                                        dispatch(getAllOperator(token));
                                                        dispatch(getAllTypeNovelty(token));
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setShowOverlay(!showSibarRight);
                                                        setEstablishmentSelect([]);
                                                        setOperatorSelect([]);
                                                        setTypeNoveltySelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-noveltya"
                                                    name="filtro-noveltya"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_operator && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Operario</label>
                                                                <Select
                                                                    options={operator}
                                                                    isMulti={false}
                                                                    onChange={handleChangeOperatorFilter}
                                                                    value={operator_select_filter}
                                                                />
                                                                {/*<SelectInput*/}
                                                                {/*    label="Tipo de novedad"*/}
                                                                {/*    name="id_tipo_novedad"*/}
                                                                {/*    options={typeNovelty.map((i) => ({*/}
                                                                {/*        name: i.label,*/}
                                                                {/*        id: i.value,*/}
                                                                {/*    }))}*/}
                                                                {/*    onChange={handleChangeFilter}*/}
                                                                {/*/>*/}
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_type_novelty && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Tipo de novedad</label>
                                                                <Select
                                                                    options={typeNovelty}
                                                                    isMulti={false}
                                                                    onChange={handleChangeTypeNoveltyFilter}
                                                                    value={type_novelty_select_filter}
                                                                />
                                                                {/*<SelectInput*/}
                                                                {/*    label="Operario"*/}
                                                                {/*    name="id_operario"*/}
                                                                {/*    options={operator.map((i) => ({*/}
                                                                {/*        name: i.label,*/}
                                                                {/*        id: i.value,*/}
                                                                {/*    }))}*/}
                                                                {/*    onChange={handleChangeFilter}*/}
                                                                {/*/>*/}
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_establishment && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label className="form-label">Establecimiento</label>
                                                                <Select
                                                                    options={establishment}
                                                                    isMulti={false}
                                                                    onChange={handleChangeEstablishmentFilter}
                                                                    value={establishment_select_filter}
                                                                />
                                                                {/*<SelectInput*/}
                                                                {/*    label="Establecimiento"*/}
                                                                {/*    name="id_establecimiento"*/}
                                                                {/*    options={establishment.map((i) => ({*/}
                                                                {/*        name: i.label,*/}
                                                                {/*        id: i.value,*/}
                                                                {/*    }))}*/}
                                                                {/*    onChange={handleChangeFilter}*/}
                                                                {/*/>*/}

                                                            </li>
                                                        </>
                                                    }
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {

                                    permisos.filter(element => element.codigo === "add_novelty").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="noveltya">
                                                        Nueva Novedad
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimiento</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={false}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Tipo de novedad</label>
                                                            <Select
                                                                options={typeNovelty}
                                                                isMulti={false}
                                                                onChange={handleChangeTypeNovelty}
                                                                value={type_novelty_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Operario</label>
                                                            <Select
                                                                options={operator}
                                                                isMulti={false}
                                                                onChange={handleChangeOperator}
                                                                value={operator_select}
                                                            />
                                                            <br/>
                                                            <Input
                                                                 type="datetime-local"
                                                                name="fecha_novedad"
                                                                id="fecha_novedad"
                                                                label="Fecha"
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                value={form.fecha_novedad}
                                                            />
                                                            <TextArea
                                                                id="comentario"
                                                                name="comentario"
                                                                label="Comentario"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.comentario}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Empleados</label>
                                                            <Select
                                                                options={employees}
                                                                isMulti={true}
                                                                onChange={handleChangeEmployee}
                                                                value={employee_select}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR NOVELTY
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                { permisos && permisos.filter(x => x.codigo === 'generate_report_novelty').length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}

                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.establecimiento + ' (' + item.codigo_establecimiento + ')'}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={'Fecha: ' + item.fecha_novedad}
                                                                    bulletType={"success"}
                                                                    children={
                                                                        <>
                                                                            <div className="user-details div_fecha">
                                                                                <div className="mail-items">
                                                                                    {(permisos && permisos.filter(x => x.codigo === 'see_operator').length > 0) &&
                                                                                        <><small>Operario: {item.operario}</small><br/></>
                                                                                    }
                                                                                    <span>Tipo: </span>{item.tipo_novedad}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}
                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.establecimiento + ' (' + DataSelected.codigo_establecimiento + ')'}
                                                                subtitle={DataSelected.fecha_novedad}
                                                            >
                                                                <div className="row">
                                                                    <div className="col-12 mb-1">
                                                                        <h6>Tipo: </h6>{DataSelected.tipo_novedad}
                                                                    </div>
                                                                    {(permisos && permisos.filter(x => x.codigo === 'see_operator').length > 0) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Operario: </h6>{DataSelected.operario}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.empleados) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Empleados: </h6>{DataSelected.empleados}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.comentario) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Comentario: </h6>{DataSelected.comentario}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.foto) &&
                                                                        <div className="col-12 mb-1">
                                                                            {/*eslint-disable-next-line*/}
                                                                            <a href={`${URLAPI}${DataSelected.foto}`} target="_blank" className="btn btn-info">
                                                                                Ver foto
                                                                            </a>
                                                                            {/*<h6>Imagen</h6>*/}
                                                                            {/*<div className="text-center">*/}
                                                                            {/*    <img*/}
                                                                            {/*        src={`${URLAPI}${DataSelected.foto}`}*/}
                                                                            {/*        alt="imagen"*/}
                                                                            {/*        width={300}*/}
                                                                            {/*    />*/}
                                                                            {/*</div>*/}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.nota) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Notas: </h6>{DataSelected.nota}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.observacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {
                                                                            (permisos.filter(x => x.codigo === 'change_novelty').length > 0 && (!DataSelected.nota && !DataSelected.foto)) &&
                                                                                <Button
                                                                                    text="Actualizar"
                                                                                    onChange={
                                                                                        () => {
                                                                                            setNota("");
                                                                                            setFoto("");
                                                                                            setModalNota(true);
                                                                                        }
                                                                                    }
                                                                                    theme="primary"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                        }
                                                                        {
                                                                            (permisos.filter(x => x.codigo === 'update_novelty').length > 0) &&
                                                                                <Button
                                                                                    text="Actualizar Novedad"
                                                                                    onChange={
                                                                                        () => {
                                                                                            dispatch(getAllTypeNovelty(token));
                                                                                            setObservation(DataSelected.observacion ? DataSelected.observacion : '');
                                                                                            setIdType(parseInt(DataSelected.id_tipo_novedad));
                                                                                            setDateNovelty(DataSelected.fecha_novedad);
                                                                                            setTypeNoveltySelect([{value: DataSelected.id_tipo_novedad, label: DataSelected.tipo_novedad}]);
                                                                                            setModalUpdateNovelty(true);
                                                                                        }
                                                                                    }
                                                                                    theme="info"
                                                                                    classes="button_div1"
                                                                                    type="button"
                                                                                    disabled={isLoading}
                                                                                />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modalNota}>
                <form onSubmit={handleUpdateSubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Actualizar</h5>
                        <div className="form-group">
                            <Input
                                label="Imagen"
                                name="imagen"
                                type="file"
                                accept="image/*"
                                onChange={(e) => setFoto(e.target.files[0])}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Nota"
                                name="nota"
                                onChange={(e) => setNota(e.target.value)}
                                value={nota}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalNota(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalUpdateNovelty}>
                <form onSubmit={handleUpdateNoveltySubmit}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Actualizar información</h5>
                        <div className="form-group">
                            <label className="form-label">Tipo de novedad</label>
                            <Select
                                options={typeNovelty}
                                isMulti={false}
                                onChange={(e) => {
                                    setIdType(parseInt(e.value));
                                    setTypeNoveltySelect(e);
                                }}
                                value={type_novelty_select}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                 type="datetime-local"
                                name="dateNovelty"
                                label="Fecha de novedad"
                                onChange={(e) => setDateNovelty(e.target.value)}
                                placeholder=""
                                value={dateNovelty}
                            />
                        </div>
                        <div className="form-group">
                            <TextArea
                                label="Observación"
                                name="observation"
                                onChange={(e) => setObservation(e.target.value)}
                                value={observation}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalUpdateNovelty(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default NovedadesAdmin;
